<template lang="pug">
v-progress-circular(:value="value" :rotate="-90" color="face-match")
  span(v-if="text")  {{ value }}
</template>

<script>
export default {
  name: 'FaceMatchIcon',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    text: {
      type: Boolean,
      default: false,
    }
  },
}
</script>
